export const ABSENCE_BLOCK_POSITION_START = 'start';
export const ABSENCE_BLOCK_POSITION_MIDDLE = 'middle';
export const ABSENCE_BLOCK_POSITION_END = 'end';
export const ABSENCE_BLOCK_POSITION_SINGLE = 'single';

export const DB_CLICK_THRESHHOLD = 300;
export const ABS_MONTH_VIEW = 'resourceTimelineMonth';
export const ABS_HALF_MONTH_VIEW = 'resourceTimelineHalfMonth';
export const ABS_DAY_VIEW = 'resourceTimelineDay';
export const ABS_DEFAULT_START_TIME = '8:00';
export const ABS_DEFAULT_END_TIME = '17:00';
